export class YChartsSentryUtils {
    static async captureException(exception, captureContext) {
        // NOTE: (3/30/23) We lazy load the sentry javascript package when it is needed not on
        //       initial page load since it increases load and evaluation time of our application
        //       which can hurt performance.
        const Sentry = (await import('./sentry-wrapper')).default;
        Sentry.captureException(exception, captureContext);
    }
}
